import { Button } from "@heroui/react";
import { Plus } from "lucide-react";
import { useState } from "react";

import { ProductListTable } from "@/components/product/table";
import { useGetAllProducts } from "@/hooks/api/product/useGetAllProducts";
import { useProductFilters } from "@/hooks/useProductFilters";
import { AppPage } from "@/layouts/page";

export function ProductsPage() {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const { filters, setFilter, setFilters, clearFilters } = useProductFilters();

  const { data: products, isFetching: isProductsLoading } = useGetAllProducts({
    ...filters,
  });

  const handlePageChange = (newPage: number) => {
    setFilter("page", newPage);
  };

  const handleLimitChange = (newLimit: number) => {
    setFilters({ limit: newLimit, page: 1 });
  };

  return (
    <AppPage
      action={
        <Button onPress={() => setIsAddOpen(true)}>
          <Plus className="size-4" />
          Add Product
        </Button>
      }
      subtitle={
        products
          ? `${products.total} products in the catalog`
          : "Manage your product catalog"
      }
      title="Products"
    >
      <ProductListTable
        changePage={handlePageChange}
        clearFilters={clearFilters}
        filters={filters}
        isAddOpen={isAddOpen}
        isLoading={isProductsLoading}
        items={products?.data ?? []}
        limit={filters.limit ?? 10}
        page={filters.page ?? 1}
        setFilter={setFilter}
        setFilters={setFilters}
        totalPage={products?.totalPages ?? 100}
        totalProducts={products?.total ?? 100}
        onAddOpenChange={setIsAddOpen}
        onLimitChange={handleLimitChange}
      />
    </AppPage>
  );
}
